import './assets/libs/boxicons-2.1.1/css/boxicons.min.css'
import './scss/App.scss'
import { BrowserRouter, Routes, Route } from 'react-router-dom'

  
import Industry from './components/industry/Industry'
import Indivual from './components/indivual/Indivual'
import Institution from './components/institution/Institution'
import TradeUnion from './components/tradeunion/TradeUnion'
import Association from './components/association/Association'
import LifeMember from './components/lifemember/LifeTime'
import Student from './components/student/Student'
import SeniorCitizen from './components/seniorcitizen/SeniorCitizen'
import UserSelection from './components/card/UserSelection'

function App() {


    return (
        <BrowserRouter>
            <Routes>
                <Route path="/form" element={<UserSelection />} />

            <Route path="/form/industry" element={<Industry />} />
                <Route path='/form/indivual' element={<Indivual />} />
                <Route path='/form/institution' element={<Institution />} />

                <Route path='/form/tradeunion' element={<TradeUnion />} />
                <Route path='/form/association' element={<Association />} />
                <Route path='/form/lifemember' element={<LifeMember />} />
                <Route path='/form/student' element={<Student />} />
                <Route path='/form/seniorcitizen' element={<SeniorCitizen />} />
                

                </Routes>
        </BrowserRouter>
    )
}

export default App
